import { Burger, Scrollbar } from '../core'
import { Mobile } from '../core'

const INITIAL_MAX_HEIGHT = 100

export default {

  init() {
    $.mlmi = {
      mobile: new Mobile(),
    }

    /* Open/Close menu */
    $('.header .js-open-menu').click(function() {
      $('body').addClass('--menu-open')
    });

    $('.header .js-close-menu').click(function() {
      $('body').removeClass('--menu-open')
    });

    /* Burger */
    let obj = this
    obj.burger = new Burger('.header__burger', {
      onToggle: function() {
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
        }
      },
    })

    checkScrollingPosition();

    //Header width background
    $( window ).scroll(function() {
      checkScrollingPosition()
    });

    function checkScrollingPosition() {
      var current_pos = $(window).scrollTop();
      if(current_pos > 50){
        $('.header').addClass('header--scrolling');
      }else{
        $('.header').removeClass('header--scrolling');
      }
    }

    // Create submenu opening
    $('ul.main-menu__sub-menu').each(function() {
      $(this).wrap('<div class="main-menu__height-ruler"></div>')
      $(this).closest('.main-menu__height-ruler').css('--height', $(this).outerHeight() + 'px')
    })

    $('.main-menu__item--parent > a').click(function() {
      $(this).closest('.main-menu__item--parent').find('.main-menu__height-ruler').css('--height', $(this).closest('.main-menu__item--parent').find('.main-menu__sub-menu').outerHeight() + 'px')
      $(this).closest('.main-menu__item--parent').toggleClass('--open')
      return false;
    })

    var column1 = $('<div class="menu-wrapper"></div>');
    var column2 = $('<div class="menu-wrapper"></div>');
    var items = $('.main-menu > li')
    var halfway = Math.ceil(items.length / 2);
    items.each(function(index) {
      if (index + 1 <= halfway) {
        column1.append($(this));
      } else {
        column2.append($(this));
      }
    })
    $('.main-menu').append(column1);
    $('.main-menu').append(column2);

    $(window).on('load resize orientationchange', function(){
      $('ul.main-menu__sub-menu').each(function() {
        $(this).closest('.main-menu__height-ruler').css('--height', $(this).outerHeight() + 'px')
      })
    })
  }
}
